import { Routes } from '@angular/router';
import { authGuard } from '@app/core/guards/auth-guard.service';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout/main-layout.component';

const children: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        canActivate: [authGuard],
        loadChildren: () => import('./features/home/home.routing').then(m => m.routes),
        data: { pageTitle: 'Home' }
    },
    {
        path: 'account',
        canActivate: [authGuard],
        loadChildren: () => import('./features/account/account.routing').then(m => m.routes),
        data: { pageTitle: 'Account' }
    },
    {
        path: 'user',
        canActivate: [authGuard],
        loadChildren: () => import('./features/user/user.routing').then(m => m.routes),
        data: { pageTitle: 'User Permissions' }
    },
    {
        path: 'controller',
        canActivate: [authGuard],
        loadChildren: () => import('./features/controller/controller.routing').then(m => m.routes),
        data: { pageTitle: 'Controller' }

    },
    {
        path: 'manual-ops',
        canActivate: [authGuard],
        loadChildren: () => import('./features/manual-ops/manual-ops.routing').then(m => m.routes),
        data: { pageTitle: 'Manual Ops' }
    },
    {
        path: 'map-setup',
        canActivate: [authGuard],
        loadChildren: () => import('./features/map/map.routing').then(m => m.routes),
        data: { pageTitle: 'Map' }
    },
    {
        path: 'shutdown',
        canActivate: [authGuard],
        loadChildren: () => import('./features/shutdown/shutdown.routing').then(m => m.routes),
        data: { pageTitle: 'Shutdown' }

    },
    {
        path: 'weather',
        canActivate: [authGuard],
        loadChildren: () => import('./features/weather/weather.routing').then(m => m.routes),
        data: { pageTitle: 'Weather' }

    },
    {
        path: 'report',
        canActivate: [authGuard],
        loadChildren: () => import('./features/report/report.routing').then(m => m.routes),
        data: { pageTitle: 'Report' }
    },
    {
        path: 'program',
        canActivate: [authGuard],
        loadChildren: () => import('./features/program/program.routing').then(m => m.routes),
        data: { pageTitle: 'Program' }
    },
    {
        path: 'help',
        canActivate: [authGuard],
        loadChildren: () => import('./features/help/help.routing').then(m => m.routes),
        data: { pageTitle: 'Help' }
    },
    {
        path: '',
        loadChildren: () => import('./features/miscellaneous/miscellaneous.routing').then(m => m.routes),
        data: { pageTitle: 'Miscellaneous' }
    }

];

export const routes: Routes = [
    {
        path: '',
        canActivate: [authGuard],
        component: MainLayoutComponent,
        data: { pageTitle: 'Home', shell: true },
        children: children
    },
    // The PDA shell mounted every application route a second time under /pda, rendered without
    // header or sidebar. It has no entry point: nothing links to /pda, and the isPDA query
    // parameter the dashboard bar reads is never set by anything in the repository. Commented out
    // rather than deleted because the code it points at is shared with the live tree and the
    // decision may be revisited. Its 41 visual-gate entries and 40 baselines were removed with it,
    // because a commented-out route answers the wildcard and the gate would have photographed the
    // Ah Snap page instead (AB#24053).
    // {
    //     path: 'pda',
    //     canActivate: [authGuard],
    //     component: MainLayoutComponent,
    //     data: { pda: true, shell: true },
    //     children: children
    // },

    {
        path: '',
        component: AuthLayoutComponent,
        loadChildren: () => import('./features/auth/auth.routing').then(m => m.routes),
    },

    { path: '**', redirectTo: 'ah-snap' }

];
